import { defineNuxtPlugin } from '#app'
import 'intro.js/introjs.css'

export default defineNuxtPlugin(async (nuxtApp) => {
  // Só executa no lado do cliente
  if (import.meta.server) {
    return
  }

  try {
    // Importação dinâmica do intro.js (seguindo documentação oficial)
    const introJs = (await import('intro.js')).default

    // Disponibilizar globalmente
    nuxtApp.provide('introJs', introJs)

    // Para uso global conforme documentação
    if (typeof window !== 'undefined') {
      (window as any).introJs = introJs
    }
  } catch (error) {
    // Fallback silencioso
  }
})
